import React from "react";
import { Colors, Icon } from "@blueprintjs/core";
import CountIconStyle from "app/CountIconStyle";

const CommentCount = props => {
  const { commentCount } = props;
  if (!commentCount) return null;
  const result = commentCount.result;
  const loading = !result;
  const count = loading ? "⌛" : result.total;
  return (
    <CountIconStyle
      loading={loading}
      muted={loading || !(count > 0)}
      activeTextColor={Colors.BLUE3}
      activeIconColor={Colors.BLUE4}
    >
      <Icon iconName="comment" className="count-icon" title="Comments" />
      <span className="count">{count}</span>
    </CountIconStyle>
  );
};

export default CommentCount;



// WEBPACK FOOTER //
// ./src/app/comments/CommentCount.js